import Founder from "../assets/images/client/founder.jpg";
import MDirector from "../assets/images/client/MD.jpg";
import DDirector from "../assets/images/client/DD.jpg";
import HRD from "../assets/images/client/HRD.jpg";

export const MEMBERS = [
  {
    id: 1,
    name: "Mr. B.L. Kumawat",
    prfoilePicture: Founder,
    designation: "Founder / Chairman",
    linkedin:
      "https://www.linkedin.com/in/svm-builders-and-developers-4a59481a0/?originalSubdomain=in",
    fb: "https://www.facebook.com/profile.php?id=100064151886759",
    ig: "https://www.instagram.com/svmbuildersanddevelopers0326/",
    about: `
    “Mr.Babulal .L. Kumawat” has been on the Board of Directors
                since the inception of SVM Builders & Developers. Born on April
                4, 1962,in Rajasthan, A Born businessman,he started his real
                estate carrier as a construction contractor in Muskat in 1976’s
                and returned to india in 1982’s and started doing the same in
                different regions of the country,and in 1990’s came to surat and
                after having studied the complete vision and development
                structure mission of the city he decided now its time to move a
                step ahead and in 2004 he placed a foundation of a Real estate
                company, “SVM Builders & Developers” With a Mission to develop
                quality properties based on realistic values for its owners,
                investment affiliates, as well as its joint venture partners.
                With almost four decades of experience in the real estate
                industry, he brings on board his unique vision, management
                practices and global approach to the function, expansion,
                diversification and management of the organisation. As an
                integral part of the key management, he manages a portfolio
                spanning across Residential, Office Space, Retail, Hospitality
                and Social Infrastructure projects. With passion for design, he
                gets involved in every project and envisions it as if he were to
                personally use it.
    
    `,
    tagline: `SVM Builders & Developers, is achieving milestones under the dynamic leadership of, Mr. Babulal .L. Kumawat`,
  },
  {
    id: 2,
    name: "Mr.Vikram B. Kumawat",
    prfoilePicture: MDirector,
    designation: "Managing Director",
    linkedin:
      "https://www.linkedin.com/in/svm-builders-and-developers-4a59481a0/?originalSubdomain=in",
    fb: "https://www.facebook.com/profile.php?id=100064151886759",
    ig: "https://www.instagram.com/svmbuildersanddevelopers0326/",
    about: `
    “Mr. Vikram B Kumawat” is responsible for the day to day operations of the company.His Stewardship of SVM Builders & Developers  spans over half a Decade. Mr. V B Kumawat,Has Inculcated within The company a culture of excellence and innovation,built around quality,customer centricity,technology and sustainable practices,manifested in SVM’s Customers trust winning project portfolio.He aims to offer innovative and world –class realty solutions to all its occupants.
    
    `,
    tagline: `“Mr. V B Kumawat” works with a motto to provide , best quality, luxurios life- style, and trust all together under one roof`,
  },
  {
    id: 3,
    name: "Mr.Sanjay B. Kumawat",
    prfoilePicture: DDirector,
    designation: "Operations & Development Director",
    linkedin:
      "https://www.linkedin.com/in/svm-builders-and-developers-4a59481a0/?originalSubdomain=in",
    fb: "https://www.facebook.com/profile.php?id=100064151886759",
    ig: "https://www.instagram.com/svmbuildersanddevelopers0326/",
    about: `
    “Mr. Sanjay B Kumawat” ,entired the real estate industry with a passion to build dream abodes for the homebuyers, Being a commited,passionate and hard-working person, he is true innovator and a farsighted man, Who excels in bringing the best practices around customers relations in business. Apart from his passion of building sustainable homes for buyers, his interests include sports, social causes, cultural activites, travelling and art.    
    `,
    tagline: `
    “Mr.S B Kumawat”, plays a major role in building confidence and good relationships with external and internal customers and oversees the critical task of building a suitable image and reputation for the company
    `,
  },
  {
    id: 4,
    name: "Mr. Mahendra M Kumawat",
    prfoilePicture: HRD,
    designation: "HRD & Marketing Director",
    linkedin:
      "https://www.linkedin.com/in/svm-builders-and-developers-4a59481a0/?originalSubdomain=in",
    fb: "https://www.facebook.com/profile.php?id=100064151886759",
    ig: "https://www.instagram.com/svmbuildersanddevelopers0326/",
    about: `
    “Mr. Mahendra M Kumawat”, Joined the company in mid 2014, with his exceptional talent in analyzing & managing the marketing budget, and ensuring that all marketing material is in line with the companies brand identity. He also ensures the safety and good quality work as well as HRD (Human Resource Developmet) for the work force to meet the customer’s deadlines for the project completion.
    `,
    tagline: `
    “Mr. Mahendra M Kumawat” plays a critical role in Sales Of the Project within the budget & time period, and meet the customer satisfaction as assured by the Managing & Developing Director of the company
    `,
  },
];
